export default __webpack_public_path__ + "ed4bd5ba81e09b7fcfff003b8a676417.png";